import React from 'react';
import PropTypes from 'prop-types';
import './MenuIcon.css';

const MenuIcon = ({ isOpened }) => (
  <div id="nav-icon4" className={isOpened ? 'open' : ''}>
    <span />
    <span />
    <span />
  </div>
);

MenuIcon.propTypes = {
  isOpened: PropTypes.bool.isRequired,
};

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/assets/MenuIcon.jsx